import type { SxStyle } from '@aibees/shared/theme';

export const root: SxStyle = {
  display: 'flex',
  flexDirection: 'column',
  gap: (p) => p.spacing(2),
  pr: 3.5,
  pl: 1.5,
  pt: 1,
  pb: 3,
  backgroundColor: (p) => p.palette.common.white,
};
